import { Components, Theme } from '@mui/material/styles';

export const flowButtonBase: Components<Theme>['MuiButtonBase'] = {
  defaultProps: {
    disableRipple: true,
  },
  styleOverrides: {
    root: {
      '& .MuiTouchRipple-root, & .MuiTouchRipple-root > span': {
        // remove generic maxWidth limitation
        maxWidth: 'none',
      },
    },
  },
};
